// extracted by mini-css-extract-plugin
module.exports = {"box":"navigation_box__LtMow","nav":"navigation_nav__3ZBPm","list":"navigation_list__1AP2l","current":"navigation_current__3uH7D"};